module.exports = __webpack_public_path__ + "static/media/51.1d52207a.png";